'use strict';

angular.module('atex.dam').controller('DamThumbViewController', ['$scope','$rootScope','ContentService', '$sce','configuration',
function($scope, $rootScope, ContentService, $sce,configuration) {
  
  $scope.expanderItem = undefined;
  $scope.expanderItemImg = undefined;
  $scope.expanderItemHeadline = undefined;
  $scope.expanderItemDesc = undefined;
  $scope.expanderItemCaption = undefined;
  $scope.expanderItemOrganization = undefined;
  $scope.expanderItemByline = undefined;
  $scope.gettingContent = false;
  $scope.isVideo = false;
  $scope.currentWebmUrl = undefined;
  $scope.currentMp4Url = undefined;
  $scope.videoThumb = undefined;


  $scope.pGalleryFields = configuration.getPGalleryFields();

  $scope.getExpander = function(field) {
    var ret;
    if (field !== undefined){
      field = field.toString().toLowerCase();
      if (field === "headline"){
        ret = $scope.expanderItemHeadline;
      }else if (field === "caption"){
        ret = $scope.expanderItemCaption;
      }else if (field === "organization"){
        ret = $scope.expanderItemOrganization;
      }else if (field === "byline"){
        ret = $scope.expanderItemByline;
      }else if (field === "desc" || field === "description"){
        ret = $scope.expanderItemDesc;
      }
    }
    return ret;
  };

  $scope.setCurrentItem = function(item) {
    $scope.expanderItem = item;
    $scope.expanderItemImg = undefined;
    $scope.expanderItemHeadline = undefined;
    $scope.expanderItemDesc = undefined;
    $scope.expanderItemCaption = undefined;
    $scope.expanderItemOrganization = undefined;
    $scope.expanderItemByline = undefined;
    if (item===undefined) {
      return;
    }
    $scope.gettingContent = true;
    if (item._data.aspects.contentData.data.objectType !== "video") {
      $scope.expanderItemImg = item._data.aspects.contentData.data.thumbUrl!==undefined ? item._data.aspects.contentData.data.thumbUrl : undefined;
    } else {
      $scope.expanderItemImg = undefined;
    }
    var transferInfo = { id: item.id, variant:"preview" };
    $scope.isVideo = undefined;
    ContentService.getContent(transferInfo).then(function(response) {
      $scope.gettingContent = false;
      atex.dam.AngularUtils.fixUrls(response.data);
      if (item._data.aspects.contentData.data.objectType==="image") {
        $scope.expanderItemImg = response.data.aspects.contentData.data.url;
      }
      $scope.expanderItemHeadline = response.data.aspects.contentData.data.name || response.data.aspects.contentData.data.title || response.data.aspects.contentData.data.headline || "No Name";
      $scope.expanderItemDesc = response.data.aspects.contentData.data.description;
      $scope.expanderItemCaption = response.data.aspects.contentData.data.caption;
      $scope.expanderItemOrganization = response.data.aspects.contentData.data.organization;
      $scope.expanderItemByline = response.data.aspects.contentData.data.byline;
      $scope.isVideo = atex.dam.AngularUtils.hasVideo(response.data);
      $scope.videoThumb = undefined;
      $scope.currentMp4Url = undefined;
      $scope.currentWebmUrl = undefined;
      if (response.data.aspects.contentData.data.objectType==="video") {
        $scope.videoThumb = response.data.aspects.contentData.data.thumbUrl;
        $scope.currentMp4Url = response.data.aspects.contentData.data.mp4Url;
        $scope.currentWebmUrl = response.data.aspects.contentData.data.webmUrl;
      } else if (response.data.aspects.contentData.data.objectType==="instagram") {
        $scope.expanderItemDesc = response.data.aspects.contentData.data.caption;
        if ($scope.isVideo) {
          $scope.videoThumb = response.data.aspects.contentData.data.url;
          $scope.currentMp4Url = $sce.trustAsResourceUrl(response.data.aspects.contentData.data.standardVideoUrl);
        } else {
          $scope.expanderItemImg = response.data.aspects.contentData.data.url;
        }
      }
      var element = $scope.getItemElement(item);
      //element.scrollIntoView();
      var thumbGrid = $("#dam-thumb-grid");
      thumbGrid.animate({
        scrollLeft: element[0].offsetLeft - (thumbGrid.width() - element.width()) / 2
      }, 200);
    }).then(null, function(error) {
       $scope.gettingContent = false;
      console.log('ERROR Getting content in DamThumbViewController::setCurrentItem:', error);
    });
    
  };
  
  $scope.getItemElement = function(item) {
    var element = $("#dam-thumb-grid a[contentid='"+item.id+"']");
    return element;
  };

  $scope.toggleExpander = function(item, $event, isThumbnail) {
    if (item===undefined || $event.ctrlKey===true || $event.metaKey===true || $event.shiftKey===true) {
      return;
    }

    $scope.setCurrentItem(item);
  };
  
  $scope.goFwd = function() {
    var currIndex = $scope.entries.indexOf($scope.expanderItem);
    if (currIndex<0 || currIndex>$scope.entries.length-1) {
      return;
    }
    if (currIndex===$scope.entries.length-1) {
      if ($scope.querying!==true && $scope.showloadmore===true) {
        $scope.loadMore();
        return;
      }
      return;
    }
    $scope.setCurrentItem($scope.entries[currIndex+1]);
  };
  
  $scope.goPrw = function() {
    var currIndex = $scope.entries.indexOf($scope.expanderItem);
    if (currIndex===0 || currIndex>$scope.entries.length-1) {
      return;
    }
    $scope.setCurrentItem($scope.entries[currIndex-1]);
  };

  $scope.setCurrentItem($scope.entries[0]);

}]);